import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=06eac84c&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=babel&"
export * from "./banner.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eac84c",
  null
  
)

export default component.exports